function cfj_on_thumbnail_click() {
  const product_items = document.querySelectorAll('.thumbnail-item-link');
  product_items.forEach(function(item) {
    item.addEventListener('click', function() {
      const parentItem = findParentItem(this, 'grid-view-item');
      const newItemImage = document.createElement('img');
      const currentItemLink = parentItem.querySelector('.grid-view-item__link');
      const currentItemImage = parentItem.querySelector('.grid-view-item__image');
      const newSrc = this.getAttribute('data-medium-src'); 
      const variantSrc = this.getAttribute('data-variant-src');
      newItemImage.classList.add('grid-view-item__image', 'lazyload');
      newItemImage.src = newSrc;
      // newItemImage.dataset.src = newSrc; 
      // newItemImage.dataset.widths = JSON.stringify([180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]); 
      // newItemImage.dataset.aspectratio = ''; 
      // newItemImage.dataset.sizes = 'auto'; 
      // newItemImage.dataset.image = ''; 
      currentItemLink.setAttribute('href', variantSrc);
      // currentItemLink.classList.add('disable-hover-overlay');
      currentItemImage.replaceWith(newItemImage);
    });
  }); 
}

function cfj_on_thumbnail_hover() {
  const product_items = document.querySelectorAll('.thumbnail-item-link');
  product_items.forEach(function(item) {
    item.addEventListener('mouseover', function() {
      const parentItem = findParentItem(this, 'grid-view-item');
      const newItemImage = document.createElement('img');
      const currentItemLink = parentItem.querySelector('.grid-view-item__link');
      const currentItemImage = parentItem.querySelector('.grid-view-item__image');
      const newSrc = this.getAttribute('data-medium-src'); 
      const variantSrc = this.getAttribute('data-variant-src');
      newItemImage.classList.add('grid-view-item__image', 'lazyload');
      newItemImage.src = newSrc;
      currentItemLink.setAttribute('href', variantSrc);
      currentItemImage.replaceWith(newItemImage);
    });
  }); 
}

function findParentItem(element, parent_class_name) {
  let parent = element.parentNode;
  while (parent) {
    if (parent.classList.contains(parent_class_name)) {
      return parent;
    }
    parent = parent.parentNode;
  }
  return null;
}


document.addEventListener('DOMContentLoaded', function() {    
    cfj_on_thumbnail_hover();
});
